import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import PilotageRh from "../features/pilotage_rh";

/* PILOTAGE RH */
export const pilotageRhRoutes = (
    <Route
        path={ROUTES.pilotage_rh.home}
        element={<PilotageRh />}
        key="pilotage_rh"
    />
);
